import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import DoneAllIcon from '@mui/icons-material/DoneAll';

interface IFinishTestDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  categoriesDone: number;
  categoriesTotal: number;
}

const FinishTestDialog: React.FC<IFinishTestDialogProps> = ({
  open,
  onClose,
  onConfirm,
  categoriesDone,
  categoriesTotal,
}) => {
  const left = categoriesTotal - categoriesDone;

  return (
    <Dialog disableScrollLock fullWidth maxWidth={'xs'} onClose={onClose} open={open}>
      <DialogTitle>
        <Stack alignItems={'center'} direction={'row'} spacing={1.5}>
          <FlagIcon color={'primary'} />
          <Typography sx={{ fontWeight: 800 }} variant={'h3'}>
            {'Завершити тест?'}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: 'text.secondary' }}>
          {left > 0
            ? `Пройдено ${categoriesDone} з ${categoriesTotal} категорій. Ще ${left} не пройдено — непозначені слова врахуються як «Не вивчено». Завершити зараз?`
            : 'Усі категорії пройдено. Готові подивитись результати?'}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={onClose}>{'Скасувати'}</Button>
        <Button
          onClick={onConfirm}
          startIcon={<DoneAllIcon />}
          variant={'contained'}
        >
          {'Завершити тест'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FinishTestDialog;
